export const defaultB = '#FFFFFF'
export const primaryB = '#7F56D9'
export const primaryB2 = '#F9F5FF'
export const secondaryB = '#F9F5FF'
export const secondaryBLight = 'rgba(249, 245, 255, 0.5)'
export const positiveB = '#EDFFF6'
export const negativeB = '#FFE9E9'
export const yellowB = '#FEFBE8'
export const purpleB = '#EBE9FF'
export const orangeB = '#fcdfc5'
export const blueB = '#F0F9FF'

export const defaultC = '#1D2939'
export const defaultD = '#979CA4'
export const primaryC = '#FFFFFF'
export const secondaryC = '#F4EBFF'
export const positiveC = '#4BAB43'
export const negativeC = '#FF4848'

export const darkBlue = '#1E385B'
export const secondaryBlink = '#D9C1F7'
export const yellow = '#eac808'
export const purple = '#aa23aa'
export const orange = '#f29718'

export const gray = '#B1BBC7'
export const gray2 = '#667085'

export const primary = '#6941C6'
export const primaryStatus = '#6941C6'
export const yellowStatus = '#eac808'
export const blue = '#026AA2'
